// src/components/ui/ModalComponent.js
import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import ButtonComponent from "./ButtonComponent";
import "../../modalComponentStyle.css";

const ModalComponent = ({
  open,
  title,
  content,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  isLoading = false,
  showCancel = true,
  maxWidth = "md",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth={maxWidth}
      PaperProps={{
        className: "kinova-modal-paper",
      }}
    >
      <DialogTitle>{title}</DialogTitle>

      <DialogContent
        dividers
        sx={{
          p: 0,
          overflow: "hidden",
          maxHeight: "80vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {content}
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        {showCancel && (
          <ButtonComponent
            label={cancelLabel}
            type="secondary"
            onClick={onCancel}
            disabled={isLoading}
          />
        )}
        <ButtonComponent
          label={confirmLabel}
          type="primary"
          onClick={onConfirm}
          isLoading={isLoading}
          disabled={isLoading}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalComponent;